import axios from 'axios';
import useFetchCredential from '../../hooks/useFetchCredential';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import BankList from '../../components/banks/BankList';
axios.defaults.withCredentials = true;

const BankListPage = () => {
  const { data, loading, error } = useFetchCredential(
    `${process.env.REACT_APP_API_URL}/marketers/banks`
  );

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Bank Accounts - Global Triumph Market Plus Multiconcept</title>
        <meta
          name="description"
          content="User dashboard page on Global Triumph Market Plus Multiconcept - Real estate investments and properties, properties for sales"
        />
      </Helmet>
      {data && (
        <>
          <div className="profile" style={{ paddingTop: '50px' }}>
            {/* <div> */}
            <h1 className="pageTitle">My Banks</h1>
            <br />
            <h4 className="headerInfo">
              You can see your registered bank accounts that can be used for commission withdrawal
              processes here. <br />
              To add a new bank account details, &nbsp;
              <Link to="/add-bank-account">click here</Link>
            </h4>
            <BankList data={data} />
            {/* </div> */}
          </div>
        </>
      )}
      {loading && <div style={{ color: 'red !important', fontSize: '20px' }}>Loading...</div>}
      {error && <div style={{ color: 'red !important', fontSize: '20px' }}>{error}</div>}
    </>
  );
};

export default BankListPage;
